import React, { FC, ReactElement } from "react";
import { useDashboardContext } from "../../contexts/dashboard/DashboardContext";
import DeleteIcon from '../../images/Delete.svg';
import EditIcon from '../../images/Edit.svg';
import Card from "../card/card";

interface BaseWidgetProps {
    title: string;
    footer?: ReactElement;
    onEdit: (key: string) => void;
    widgetKey: string;
    previewMode?: boolean;
    titleBackgroundColor?: string;
    titleForegroundColor?: string;
}

const BaseWidget: FC<BaseWidgetProps> = ({ children, title, footer, onEdit, widgetKey, previewMode = false, titleBackgroundColor, titleForegroundColor }) => {
    const dashboardContext = useDashboardContext();

    return <Card className="flex flex-row rounded" key={widgetKey}>
        <div id={title}
             className="w-full justify-between bg-white" style={{ minWidth: "100%" }}>
            <div id={`${dashboardContext.editMode && !previewMode ? 'widgetOverlayVisible' : 'widgetOverlayHidden'}`}
                 className={`fixed opacity-25 z-10 w-full h-full cursor-move bg-gray-400 rounded ${dashboardContext.editMode && !previewMode ? '' : 'hidden'}`}></div>
            <div id="widgetTitleBlock" style={{ backgroundColor: titleBackgroundColor }} className="flex flex-row items-center h-7 rounded-t justify-between">
                <span
                    id = "widgetTitle"
                    style={{ color: titleForegroundColor, textOverflow: "ellipsis" }}
                    className="text-sm px-2 font-semibold overflow-hidden whitespace-no-wrap"
                    title={title}>
                    {title}
                </span>
            </div>
            {children}
            {footer ? <div className="pb-2">{footer}</div> : null}
        </div>
        <div id={`${dashboardContext.editMode && !previewMode ? 'editIconsVisible' : 'editIconsHidden'}`}
             className={`${dashboardContext.editMode && !previewMode ? 'flex flex-col w-8 z-50 bg-transparent border-transparent justify-start space-y-2 pl-1' : 'hidden'}`}>
            <button
                className="flex justify-center items-center w-6 h-6 bg-white rounded-full"
                onClick={(e) => dashboardContext.onDelete(widgetKey)}
                id="deleteIcon"
                type="button">
                <img src={DeleteIcon} className="w-4 h-4" alt="Delete" />
            </button>
            <button
                className="flex justify-center items-center w-6 h-6 bg-white rounded-full"
                onClick={(e) => onEdit(widgetKey)}
                id="editIcon"
                type="button">
                <img src={EditIcon} className="w-4 h-4" alt="Edit" />
            </button>
        </div>
    </Card>
}

export default BaseWidget;
